export default __webpack_public_path__ + "static/media/styled-components.2e00d138.svg";